import { render, staticRenderFns } from "./XueYa.vue?vue&type=template&id=144313f2&scoped=true&"
import script from "./XueYa.vue?vue&type=script&lang=js&"
export * from "./XueYa.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "144313f2",
  null
  
)

export default component.exports